import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";

export function DialogHistorico({
    isVisibleHistory, setIsVisibleHistory,
    isEditing,
    formHistory, setFormHistory,
    tipos, turmas, colaboradores, oleos,
    listaFitas, listaRodas,
    onHideHistory, handleSubmit,
}) {
    return (
        <Dialog
            header="Salvar"
            onHide={() => setIsVisibleHistory(false)}
            style={{ minWidth: '50vw' }}
            visible={isVisibleHistory}
        >
            <div className="p-fluid">
                <div className="p-field">
                    <label htmlFor="hist_tear">Tear: </label>
                    <InputText id="hist_tear" readOnly value={formHistory.tear} />
                </div>

                {isEditing === false && (
                    <div className="p-field">
                        <label htmlFor="manutencao_tipo_id">Tipo de Manutenção: </label>
                        <Dropdown
                            id="manutencao_tipo_id"
                            filter
                            disabled={isEditing}
                            options={tipos}
                            optionLabel="descricao"
                            optionValue="id"
                            value={formHistory.manutencao_tipo_id}
                            onChange={e => setFormHistory({ ...formHistory, manutencao_tipo_id: e.value })}
                        />
                    </div>
                )}

                <div className="p-grid">
                    <div className="p-field p-col">
                        <label htmlFor="hist_turma">Turma: </label>
                        <Dropdown
                            id="hist_turma"
                            optionLabel="nome"
                            optionValue="id"
                            options={turmas}
                            value={formHistory.turma_id}
                            onChange={e => setFormHistory({ ...formHistory, turma_id: e.value })}
                        />
                    </div>
                    <div className="p-field p-col">
                        <label htmlFor="hist_data">Data: </label>
                        <Calendar
                            id="hist_data"
                            dateFormat="dd/mm/yy"
                            mask="99/99/9999"
                            value={formHistory.data}
                            onChange={e => setFormHistory({ ...formHistory, data: e.value })}
                        />
                    </div>
                </div>

                <div className="p-field">
                    <label htmlFor="hist_colaborador">Colaborador: </label>
                    <Dropdown
                        id="hist_colaborador"
                        filter
                        options={colaboradores}
                        optionLabel="nome"
                        optionValue="id"
                        placeholder="Escolha um dos colaboradores..."
                        value={formHistory.colaborador_id}
                        onChange={e => setFormHistory({ ...formHistory, colaborador_id: e.value })}
                    />
                </div>

                {/* Óleo */}
                {(formHistory.manutencao_tipo_id === 10 || formHistory.manutencao_tipo_id === 11) && (
                    <div className="p-field">
                        <label htmlFor="oleo_id">Óleo: </label>
                        <Dropdown
                            id="oleo_id"
                            optionLabel="nome"
                            optionValue="id"
                            options={oleos}
                            placeholder="Escolha um óleo..."
                            value={formHistory.oleo_id}
                            onChange={e => setFormHistory({ ...formHistory, oleo_id: e.value })}
                        />
                    </div>
                )}

                {/* Fita */}
                {formHistory.manutencao_tipo_id === 24 && (
                    <>
                        <div className="p-field">
                            <label htmlFor="fitas_id">Fita: </label>
                            <Dropdown
                                id="fitas_id"
                                optionLabel="nr_serie"
                                optionValue="id"
                                options={listaFitas}
                                placeholder="Escolha uma fita..."
                                value={formHistory.fitas_id}
                                onChange={e => setFormHistory({ ...formHistory, fitas_id: e.value })}
                            />
                        </div>
                        <div className="p-field">
                            <label htmlFor="passadas_fita">Passadas no Momento da Troca: </label>
                            <InputNumber
                                id="passadas_fita"
                                min={0}
                                value={formHistory.passadas}
                                onValueChange={e => setFormHistory({ ...formHistory, passadas: e.value })}
                            />
                        </div>
                    </>
                )}

                {/* Roda */}
                {formHistory.manutencao_tipo_id === 25 && (
                    <>
                        <div className="p-field">
                            <label htmlFor="rodas_id">Roda: </label>
                            <Dropdown
                                id="rodas_id"
                                optionLabel="nr_serie"
                                optionValue="id"
                                options={listaRodas}
                                placeholder="Escolha uma roda..."
                                value={formHistory.rodas_id}
                                onChange={e => setFormHistory({ ...formHistory, rodas_id: e.value })}
                            />
                        </div>
                        <div className="p-field">
                            <label htmlFor="passadas_roda">Passadas no Momento da Troca: </label>
                            <InputNumber
                                id="passadas_roda"
                                min={0}
                                value={formHistory.passadas}
                                onValueChange={e => setFormHistory({ ...formHistory, passadas: e.value })}
                            />
                        </div>
                    </>
                )}

                <div className="p-field">
                    <label htmlFor="hist_descricao">Descrição: </label>
                    <InputTextarea
                        id="hist_descricao"
                        rows={4}
                        placeholder="Descreva a situação..."
                        value={formHistory.descricao}
                        onChange={e => setFormHistory({ ...formHistory, descricao: e.target.value })}
                    />
                </div>

                <div className="p-field p-d-flex p-flex-row">
                    <Button className="p-mr-2 p-button-secondary" label="Cancelar" onClick={onHideHistory} />
                    <Button className="p-ml-2 p-button-success" label="Salvar" onClick={handleSubmit} />
                </div>
            </div>
        </Dialog>
    );
}